import { render, staticRenderFns } from "./lianbaDownLoad.vue?vue&type=template&id=e7a10e10&scoped=true&"
import script from "./lianbaDownLoad.vue?vue&type=script&lang=js&"
export * from "./lianbaDownLoad.vue?vue&type=script&lang=js&"
import style0 from "./lianbaDownLoad.vue?vue&type=style&index=0&id=e7a10e10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a10e10",
  null
  
)

export default component.exports